import { render } from "./IconAddBox.vue?vue&type=template&id=77d7d078"
import script from "./IconAddBox.vue?vue&type=script&lang=js"
export * from "./IconAddBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__